import { useContext, createContext } from "react";

export const Context = createContext({
  setFilterValues: (paramName?: string, values?: Array<any>) => {},
  clearFilterValues: (paramName?: string) => {},
  isAnyFilterSet: false,
  formState: {} as Record<string, Array<any>>,
});

const useFilterContext = () => useContext(Context);

export default useFilterContext;
